var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailReport = function SvgEmailReport(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 0.5H1.6C0.72 0.5 0 1.175 0 2V11C0 11.825 0.72 12.5 1.6 12.5H14.4C15.28 12.5 16 11.825 16 11V2C16 1.175 15.28 0.5 14.4 0.5ZM14.08 3.6875L8.848 6.755C8.328 7.0625 7.672 7.0625 7.152 6.755L1.92 3.6875C1.72 3.5675 1.6 3.365 1.6 3.1475C1.6 2.645 2.184 2.345 2.64 2.6075L8 5.75L13.36 2.6075C13.816 2.345 14.4 2.645 14.4 3.1475C14.4 3.365 14.28 3.5675 14.08 3.6875Z",
    fill: "#5547DD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "EmailReport.cd6fdac7a4eef959adf0d1c026661965.svg";